import {
  IAddNodeSuggestion,
  IDeleteNodeSuggestion,
  IInventionTreeSuggestions,
  IUpdateNodeSuggestion,
} from 'features/Launchpad/types/inventionTree';

export const findSuggestionById = (
  id: string,
  suggestions: IInventionTreeSuggestions,
):
  | boolean
  | { type: 'add'; suggestion: IAddNodeSuggestion }
  | { type: 'delete'; suggestion: IDeleteNodeSuggestion }
  | { type: 'update'; suggestion: IUpdateNodeSuggestion } => {
  const addNodes = suggestions.addNodeSuggestions;
  const updateNodes = suggestions.updateNodeSuggestions;
  const deleteNodes = suggestions.deleteNodeSuggestions;
  const foundAddSuggestion = addNodes.find(suggestion => suggestion.parentNodeId === id);
  const foundUpdateSuggestion = updateNodes.find(suggestion => suggestion.treeNodeId === id);
  const foundDeleteSuggestion = deleteNodes.find(suggestion => suggestion.treeNodeId === id);

  return (
    (foundAddSuggestion && { type: 'add', suggestion: foundAddSuggestion }) ||
    (foundUpdateSuggestion && { type: 'update', suggestion: foundUpdateSuggestion }) ||
    (foundDeleteSuggestion && { type: 'delete', suggestion: foundDeleteSuggestion }) ||
    false
  );
};

export function getInitialsFromString(name: string): string {
  return name.slice(0, 2).toUpperCase();
}

export const removeDuplicateAssignees = (assignees: string[]) => {
  const uniqueNames = new Set();
  return assignees.filter(assignee => {
    if (!uniqueNames.has(assignee)) {
      uniqueNames.add(assignee);
      return true;
    }
    return false;
  });
};

export const toTitleCase = (text: string) => {
  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// Function to convert number to Roman numeral
